import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface ScrollToTopProps {
  smooth?: boolean;
  position?: number;
  onScrollComplete?: () => void;
  excludePaths?: string[];
  scrollDelay?: number;
}

const ScrollToTop: React.FC<ScrollToTopProps> = ({
  smooth = true,
  position = 0,
  onScrollComplete,
  excludePaths = [],
  scrollDelay = 0,
}) => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (excludePaths.includes(pathname)) return;

    const targetPosition = Math.max(0, position);

    const scrollFn = () => {
      try {
        window.scrollTo({
          top: targetPosition,
          left: 0,
          behavior: smooth ? "smooth" : "auto",
        });
        onScrollComplete?.();
      } catch {
        // fallback
        window.scrollTo(0, targetPosition);
        onScrollComplete?.();
      }
    };

    if (scrollDelay > 0) {
      const timer = setTimeout(scrollFn, scrollDelay);
      return () => clearTimeout(timer);
    } else {
      scrollFn();
    }
  }, [pathname, position, smooth, excludePaths, scrollDelay, onScrollComplete]);

  return null;
};

export default ScrollToTop;
